<template>
    <DForm
        @submit.prevent="submitForm"
    >
        <DFormRow
            :label="__('tasks.table.note.label')"
            :is-required="false"
            :error="errors.note"
        >
            <DFormTextarea
                id="note"
                :model-value="note"
                rows="5"
                :is-valid="isFormFieldValid('note')"
                :disabled="disabled"
                @update:modelValue="$emit('update:note', $event)"
            />
        </DFormRow>
    </DForm>
</template>

<script>
export default {
    name: 'TaskNoteForm',
    props: {
        note: {
            type: String,
            default: null
        },
        errors: {
            type: Object,
            default: () => ({})
        },
        disabled: {
            type: Boolean,
            default: () => true
        }
    },
    emits: ['submit', 'update:note'],
    methods: {
        submitForm () {
            this.$emit('submit')
        }
    }
}
</script>
